import { render, staticRenderFns } from "./kuaidiset.vue?vue&type=template&id=29f92c92&scoped=true&"
import script from "./kuaidiset.vue?vue&type=script&lang=js&"
export * from "./kuaidiset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f92c92",
  null
  
)

export default component.exports